import { Box, Pagination, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useStyles } from "./style";
export default function HomePagePagination({
  isNavbarOpen,
  theme,
  totalItems,
  pageSize,
  currentPage,
  handlePageChange,
}) {
  const classes = useStyles({
    isNavbarOpen,
    theme,
    count: Math.ceil(totalItems / pageSize),
  });
  return (
    <Box
      id="page"
      sx={{
        display: "flex",
        width: "100%",
        flexDirection: "row",
        justifyContent: "flex-end",
      }}
    >
      <Box className={classes.pagination}>
        <Pagination
          count={Math.ceil(totalItems / pageSize)}
          page={currentPage}
          shape="circular"
          onChange={handlePageChange}
          sx={{
            fontSize: "0.8vw !important",
            "& .MuiPaginationItem-root": {
              fontSize: "0.8vw !important",
            },
            "& .MuiButtonBase-root-MuiPaginationItem-root": {
              height: "2rem",
              width: "2rem",
              borderRadius: "50%",
            },

            "& .MuiSvgIcon-root": {
              fontSize: "1.4rem",
            },
          }}
        />
        <Typography
          data-testid="homePage.PageDetails"
          className={classes.pageText}
        >
          {totalItems === 0 ? 0 : (currentPage - 1) * pageSize + 1}-
          {Math.min((currentPage - 1) * pageSize + pageSize, totalItems)} of{" "}
          {totalItems}
        </Typography>
      </Box>
    </Box>
  );
}

HomePagePagination.propTypes = {
  isNavbarOpen: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  totalItems: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  handlePageChange: PropTypes.func.isRequired,
};
